module.exports = __webpack_public_path__ + "static/img/invite2.36ec9ab2.png";